// Angular
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	OnInit,
	Renderer2
} from '@angular/core';
import { Cache } from 'aws-amplify';
import { NavigationEnd, Router, NavigationStart, ActivatedRoute } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import {
	LayoutConfigService,
	MenuConfigService,
	MenuHorizontalService,
	MenuOptions,
	OffcanvasOptions,
	MachineService
} from '../../../../core/_base/layout';
// HTML Class
import { HtmlClassService } from '../../html-class.service';
import { FeatureFlagService } from '../../../../core/_services/feature-flag.service';
import { getPortalViewFromAttributes, portalViewAllowsMenuItem } from '../../../../core/_config/portal-view';

@Component({
	selector: 'kt-menu-horizontal',
	templateUrl: './menu-horizontal.component.html',
	styleUrls: ['./menu-horizontal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuHorizontalComponent implements OnInit, AfterViewInit {
	// Public properties
	currentRouteUrl: any = '';

	rootArrowEnabled: boolean;

	isMachineSelected = true;

	menuOptions: MenuOptions = {
		submenu: {
			desktop: 'dropdown',
			tablet: 'accordion',
			mobile: 'accordion'
		},
		accordion: {
			slideSpeed: 200, // accordion toggle slide speed in milliseconds
			expandAll: false // allow having multiple expanded accordions in the menu
		},
		dropdown: {
			timeout: 50
		}
	};

	offcanvasOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-header-menu-wrapper',
		closeBy: 'kt_header_menu_mobile_close_btn',
		toggleBy: {
			target: 'kt_header_mobile_toggler',
			state: 'kt-header-mobile__toolbar-toggler--active'
		}
	};

	machine: any;

	/** When on a machine page, the machineId from the URL (for building menu links). */
	currentMachineId: string | null = null;

	menuType = null;

	showMenu = true;

	menuObj = [];

	routeValue;
	qParams;

	wholeMenuObj;

	/**
	 * Component Conctructor
	 *
	 * @param el: ElementRef
	 * @param htmlClassService: HtmlClassService
	 * @param menuHorService: MenuHorService
	 * @param menuConfigService: MenuConfigService
	 * @param layoutConfigService: LayouConfigService
	 * @param router: Router
	 * @param render: Renderer2
	 * @param cdr: ChangeDetectorRef
	 */
	constructor(
		private el: ElementRef,
		public htmlClassService: HtmlClassService,
		public menuHorService: MenuHorizontalService,
		private menuConfigService: MenuConfigService,
		private layoutConfigService: LayoutConfigService,
		private route: ActivatedRoute,
		private router: Router,
		private render: Renderer2,
		private cdr: ChangeDetectorRef,
		private machineService: MachineService,
		private featureFlagService: FeatureFlagService
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {

		const currUrl = this.router;
		this.routeValue = currUrl;

		this.route.queryParams.subscribe(qParams => {
			this.qParams = qParams;
			this.checkForURL(this.routeValue);
		});

		// const currUrl = this.router.url;
		// if (currUrl.startsWith('/machine/')) {
		// 	if (this.machine) {
		// 		this.showMenu = true;
		// 	}
		// } else {
		// 	this.showMenu = false;
		// }
		this.cdr.detectChanges();
	}

	/**
	 * On init
	 */
	ngOnInit(): void {

		console.log("on init:MH");

		this.machine = Cache.getItem('selected_machine');

		this.machineService.selectedMachine$.subscribe(mId => {
			this.machine = mId;
			this.cdr.detectChanges();
		});

		this.menuHorService.menuList$.subscribe(vals => {
			this.wholeMenuObj = vals;
			if (vals && this.router.url) {
				this.checkForURL({ url: this.router.url });
				this.cdr.markForCheck();
			}
		});

		this.router.events.subscribe((value: any) => {
			if (value instanceof NavigationStart) {
				this.routeValue = value;
				this.checkForURL(this.routeValue);
			}
		});

		this.route.queryParams.subscribe(qParams => {
			this.qParams = qParams;
			this.checkForURL(this.routeValue);
		});


		// const currUrl = this.router.url;
		// if (currUrl.startsWith('/machine/')) {
		// 	if (this.machine) {
		// 		this.showMenu = true;
		// 	}
		// } else {
		// 	this.showMenu = false;
		// }
		// this.cdr.detectChanges();

		// console.log('this.showMenu',this.showMenu);

		// this.router.events.subscribe((value: any) => {
		// 	if (value instanceof NavigationStart) {
		// 		// console.log('value.url',value.url);

		// 		if (value.url.startsWith('/machine/')) {
		// 			if (this.machine) {
		// 				this.showMenu = true;
		// 			}
		// 		} else {
		// 			this.showMenu = false;
		// 		}
		// 		this.cdr.detectChanges();
		// 	}
		// 	// // console.log('this.showMenu',this.showMenu);
		// });

		this.rootArrowEnabled = this.layoutConfigService.getConfig('header.menu.self.root-arrow');

		this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
		// Initial check for current route
		if (this.router.url && this.wholeMenuObj) {
			this.checkForURL({ url: this.router.url });
		}
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(event => {
				this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
				if (this.wholeMenuObj) {
					this.checkForURL({ url: this.router.url });
				}
				this.cdr.markForCheck();
			});
	}

	checkForURL(value) {
		if (value && value.url) {
			if (value.url.startsWith('/machine/')) {
				const segments = value.url.split('/').filter(Boolean);
				this.currentMachineId = segments[1] || null;
				if (this.machine || this.currentMachineId) {
					this.menuType = 'machine';
					this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.machine && this.wholeMenuObj.machine.items) ? this.wholeMenuObj.machine.items : [];
					this.showMenu = true;
				}
			} else if (value.url.startsWith('/clients/')) {
				this.currentMachineId = null;
				this.menuType = 'client';
				this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.clients && this.wholeMenuObj.clients.items) ? this.wholeMenuObj.clients.items : [];
				this.showMenu = true;
			} else if (value.url.startsWith('/inventory/')) {
				this.currentMachineId = null;
				this.menuType = 'inventory';
				this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.inventory && this.wholeMenuObj.inventory.items) ? this.wholeMenuObj.inventory.items : [];
				this.showMenu = true;
			} else if (value.url.startsWith('/audits')) {
				this.currentMachineId = null;
				this.menuType = 'audits';
				this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.audits && this.wholeMenuObj.audits.items) ? this.wholeMenuObj.audits.items : [];
				this.showMenu = true;
			} else {
				this.currentMachineId = null;
				this.menuType = null;
				this.menuObj = [];
				this.showMenu = false;
			}
		} else {
			this.currentMachineId = null;
			this.menuType = null;
			this.menuObj = [];
			this.showMenu = false;
		}
		this.cdr.detectChanges();
	}

	/**
	 * For machine menu items, prepend current machineId to the path so links work with /machine/:machineId/...
	 */
	getMachinePageLink(item: { page?: string }): string {
		const page = item.page || '';
		if (page.startsWith('/machine/') && this.currentMachineId) {
			return '/machine/' + this.currentMachineId + page.slice(8);
		}
		return page;
	}

	/**
	 * Return Css Class Name
	 * @param item: any
	 */
	getItemCssClasses(item) {
		let classes = 'kt-menu__item';

		if (objectPath.get(item, 'submenu')) {
			classes += ' kt-menu__item--submenu';
		}

		if (!item.submenu && this.isMenuItemIsActive(item)) {
			classes += ' kt-menu__item--active kt-menu__item--here';
		}

		if (item.submenu && this.isMenuItemIsActive(item)) {
			classes += ' kt-menu__item--open kt-menu__item--here';
		}

		if (objectPath.get(item, 'resizer')) {
			classes += ' kt-menu__item--resize';
		}

		const menuType = objectPath.get(item, 'submenu.type') || 'classic';
		if ((objectPath.get(item, 'root') && menuType === 'classic')
			|| parseInt(objectPath.get(item, 'submenu.width'), 10) > 0) {
			classes += ' kt-menu__item--rel';
		}

		const customClass = objectPath.get(item, 'custom-class');
		if (customClass) {
			classes += ' ' + customClass;
		}

		if (objectPath.get(item, 'icon-only')) {
			classes += ' kt-menu__item--icon-only';
		}

		return classes;
	}

	/**
	 * Returns Attribute SubMenu Toggle
	 * @param item: any
	 */
	getItemAttrSubmenuToggle(item) {
		let toggle = 'hover';
		if (objectPath.get(item, 'toggle') === 'click') {
			toggle = 'click';
		} else if (objectPath.get(item, 'submenu.type') === 'tabs') {
			toggle = 'tabs';
		} else {
			// submenu toggle default to 'hover'
		}

		return toggle;
	}

	/**
	 * Returns Submenu CSS Class Name
	 * @param item: any
	 */
	getItemMenuSubmenuClass(item) {
		let classes = '';

		const alignment = objectPath.get(item, 'alignment') || 'right';

		if (alignment) {
			classes += ' kt-menu__submenu--' + alignment;
		}

		const type = objectPath.get(item, 'type') || 'classic';
		if (type === 'classic') {
			classes += ' kt-menu__submenu--classic';
		}

		if (type === 'tabs') {
			classes += ' kt-menu__submenu--tabs';
		}

		if (type === 'mega') {
			if (objectPath.get(item, 'width')) {
				classes += ' kt-menu__submenu--fixed';
			}
		}

		if (objectPath.get(item, 'pull')) {
			classes += ' kt-menu__submenu--pull';
		}

		return classes;
	}

	/**
	 * Check Menu is active
	 * @param item: any
	 */
	isMenuItemIsActive(item): boolean {
		if (item.submenu) {
			return this.isMenuRootItemIsActive(item);
		}

		if (!item.page) {
			return false;
		}

		const link = this.getMachinePageLink(item);
		const current = this.currentRouteUrl || '';
		return current === link || current.startsWith(`${link}/`);
	}

	/**
	 * Check Menu Root Item is active
	 * @param item: any
	 */
	isMenuRootItemIsActive(item): boolean {
		if (item.submenu.items) {
			for (const subItem of item.submenu.items) {
				if (this.isMenuItemIsActive(subItem)) {
					return true;
				}
			}
		}

		if (item.submenu.columns) {
			for (const subItem of item.submenu.columns) {
				if (this.isMenuItemIsActive(subItem)) {
					return true;
				}
			}
		}

		if (typeof item.submenu[Symbol.iterator] === 'function') {
			for (const subItem of item.submenu) {
				const active = this.isMenuItemIsActive(subItem);
				if (active) {
					return true;
				}
			}
		}

		return false;
	}

	canShowMenuItem(item: any): boolean {
		const portalView = getPortalViewFromAttributes(Cache.getItem('userAttr'));
		if (!portalViewAllowsMenuItem(item, portalView)) {
			return false;
		}
		const featureFlag = item && item.featureFlag ? item.featureFlag : null;
		if (!featureFlag) {
			return true;
		}
		return this.featureFlagService.hasFeatureFlag(featureFlag);
	}
}
